import {
	FinancialProfileQuestionsEntry_Clicked,
	FinancialProfileQuestionsEntry_Viewed,
	Origin,
	Screen,
} from '@stashinvest/product-events-typescript';

import type { TrackFn } from 'stash/components/retirement/managed/events';

type FinancialProfileQuestionsEntryScreen =
	| typeof Screen.home
	| typeof Screen.financialProfile;

type FinancialProfileQuestionsEntryPayload = {
	screen: FinancialProfileQuestionsEntryScreen;
	origin?: typeof Origin.userProfile;
};

function buildProperties({ screen, origin }: FinancialProfileQuestionsEntryPayload) {
	return origin == null ? { screen } : { screen, origin };
}

export function trackFinancialProfileQuestionsEntryViewed(
	track: TrackFn,
	payload: FinancialProfileQuestionsEntryPayload
): void {
	track(FinancialProfileQuestionsEntry_Viewed.v1(buildProperties(payload)));
}

export function trackFinancialProfileQuestionsEntryClicked(
	track: TrackFn,
	payload: FinancialProfileQuestionsEntryPayload
): void {
	track(FinancialProfileQuestionsEntry_Clicked.v1(buildProperties(payload)));
}
